import { InviteOrganizationTeamMemberEntry } from "./InviteOrganizationTeamMemberEntry";

export class InviteOrganizationTeamMembersRequest {
    users: InviteOrganizationTeamMemberEntry[] = [];
}